module.exports = __webpack_public_path__ + "static/media/36-marco.ebd5e9a6.jpg";